<template>
  <v-main>
    <v-container>
      <v-row>
        <v-col>
          <v-card max-width="500" class="max-auto">
            <v-card-text class="text-center">
              <qrcode-vue :value="code.string" :size="size" level="H"></qrcode-vue>
              <v-divider></v-divider>
              <h3 class="text-h6 text-sm-h5 text-md-h4">QR Code Information</h3>
              <v-sheet width="100%" class="pa-4" color="grey lighten-2" elevation="10">
                <div class="text-h6 rounded-pill lighten-2">{{ code.string }}</div>
              </v-sheet>
              <br />
              <v-btn color="red" text  @click="linkTo">
                <v-icon left>mdi-earth</v-icon>
                Public Preview</v-btn>
              <v-divider light></v-divider>
            </v-card-text>
            <v-card-text>
              <v-alert type="info" color="buttons">
              <h3>
                <p class="text-body-2">
                  If your bracelet is missing, Please click the button below to change your QR CODE
                </p>
              </h3>
              <v-row justify="center">
                <v-dialog v-model="dialog" persistent max-width="390">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      class="text-center"
                    >
                      Change Code
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title class="text-body-h6 text-center">Change Your QR Code</v-card-title>
                    <v-card-text class="font-weight-bold">You have clicked to change your QR Code. <strong>Please</strong> understand that this process cannot be reversed. Every surface where your existing QR Code has been printed will no longer scan to your public account. Click OK to continue or Cancel to stop</v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="green darken-1" outlined text @click="change"><v-icon left>mdi-thumb-up</v-icon> Ok</v-btn>
                      <v-btn color="red darken-1" outlined text @click="dialog = false"> <v-icon left>mdi-thumb-down</v-icon>Cancel</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
              </v-alert >
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import { mapGetters } from "vuex";
export default {
  name: "qrcode",
  created() {
    this.$store.dispatch("qrcode/aQrCode");
  },
  components: {
    QrcodeVue
    //MainMenu
  },
  computed: {
    ...mapGetters("qrcode", {
      code: "gCodeInfo"
    })
  },
  data() {
    return {
      dialog: false,
      value: "ikenna Egwu",
      size: 250
    };
  },
  methods: {
    change() {
      this.dialog = false;
        this.$store.dispatch("qrcode/aChangeCode");
    },
    linkTo() {
      //return "https://ice.mi-sos.org/" + this.code.raw;
      this.$router.push({name: "preview", params: {code: this.code.raw}})
    }
  }
};
</script>

<style>
</style>